import { BetRequest, FrontendErrorCode, InputState, LoadInfo, MachineLockedParams, SimpleSlotGameConfiguration, SlotGameBet, SpinSuccess } from "../multigame/api";
import { AudioManager, Track } from "../multigame/AudioManager";
import { ClientState } from "../multigame/ClientState";
import { IInterval } from "../multigame/Context/Interval";
import type { ISystemContext } from "../multigame/Context/SystemContext";
import { ITimeout } from "../multigame/Context/Timeout";
import { FitScreen, GetFitType, GetOrientation, Orientation } from "../multigame/FitScreen";
import { CreateGameFactory, IGameFactory } from "../multigame/GameFactory";
import { IMultigame } from "../multigame/IMultigame";
import { Button, InputFunction } from "../multigame/IO";
import { Lock } from "../multigame/Lock";
import { MoneyFormatter } from "../multigame/MoneyFormatter";
import { AvailableButton } from "../multigame/MultigameAvailableButtons";
import { MultigameParams } from "../multigame/MultigameParams";
import { CreateElement, GetUrlParamBool, GetUrlParamString, Log, LogGroup, Scale, SetStyles, Size } from "../multigame/MyHelpers";
import { crashvideo } from "../multigame/MyVideo";
import { CSSResource } from "../multigame/ResourceManager/CSSResource";
import { FontResource } from "../multigame/ResourceManager/FontResource";
import { Resource } from "../multigame/ResourceManager/Resource";
import { ResourceIdentifier } from "../multigame/ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, LoadingStage, LoadingStageOrder, ResourceManager } from "../multigame/ResourceManager/ResourceManager";
import { RobotParamsDefault, RobotPlay, RobotPlayType } from "../multigame/RobotPlay";
import { ChangeSettings, JackpotDisplayType, Presentation, Screen3SettingDisplay, ScreenConfiguration, Settings } from "../multigame/Settings";
import { ICallAttendanMenuParams } from "../multigame/slot/CallAttendantMenu";
import { GameState } from "../multigame/slot/GameState";
import { crashcanvas } from "../multigame/slot/MyCanvas";
import { CashInParams, CashOutParams, SlotGame } from "../multigame/slot/SlotGame";
import { SlotGameType1Shared } from "../multigame/slot/SlotGameType1Shared";
import { StateMachine } from "../multigame/slot/StateMachine";
import { SlotGameInitData } from "../multigame/SlotGameInitData";
import { EnglishTranslation, SpanishTranslation, Translator } from "../multigame/Translator";
import { ZIndex } from "../multigame/ZIndex";


import { HubConnection } from "@microsoft/signalr";
import type { IBackendSettingsService } from "../services/BackendSettingsService";
import { SearchParam, SearchParamBool, SearchParamNum } from "../helpers/SearchParam";
import { ApiResultOfLoadResponseDTO, ApiResultOfSimpleSlotGameState, BetConfig, BetType, FreeRoundsStats, LoadRequestDTO, Money, ResourceMeta, ResultStatus, SimpleSlotGameState, SpinResult } from "./singlegame_api";
import { SinglegameApi } from "./singlegame_api_extended";
import { TranslationService } from "../services/TranslationService";
import { SlotGameType1_1Screen } from "../multigame/slot/SlotGameType1_1Screen";
import { DisplayType, LinkType, PopupMessage } from "../multigame/PopupMessage";
import { service } from "../multigame/services";
import { ImageResource } from "../multigame/ResourceManager/ImageResource";
import { SharedVideoContainer } from "../multigame/Context/SharedVideoContext";
import { create_ssr_component } from "svelte/internal";
import { MoneyFormatterService } from "../services/MoneyFormatterService";
import type { IMoneyFormatterService } from "../services/IMoneyFormatterService";
import { SlotGameType1_Responsive } from "../multigame/slot/SlotGameType1_Responsive";
import { SpeedManager } from "../multigame/SpeedManager";
import { SmoothLoadProgress } from "./SmoothLoadProgress";
//import { ReportResources } from "../multigame/system/CommonStartup";
import { PixiSpriteResource } from "../multigame/ResourceManager/PixiSpriteResource";
import { IJackpotDisplay } from "../multigame/JackpotDisplay/IJackpotDisplay";
import { IJackpotDisplayFactory } from "../multigame/JackpotDisplay/IJackpotDisplayFactory";
import { JackpotDisplayFactory } from "../multigame/JackpotDisplay/JackpotDisplayFactory";
import { JackpotDisplayParams } from "../multigame/JackpotDisplay/JackpotDisplayParams";
import { ScreenGameInitDataMessage, ScreenIntroductionMessage, ScreenMultigameSyncMessage, ScreenProtocol, ScreenProtocolDestination, ScreenProtocolScope, ScreenReloadMessage } from "../multigame/ScreenProtocol";
import { CrashPixi } from "../multigame/PixiDebug";
import { SlotGameType1_ResponsivePIXIApp } from "../multigame/slot/SlotGameType1_ResponsivePIXIApp";
import * as PIXI from 'pixi.js'
import { FountainPIXI } from "../multigame/slot/FountainAnimationPIXI";
import { SlotGameType1 } from "../multigame/slot/SlotGameType1";
import { SpinAndHoldBonus } from "../multigame/slot/Bonus/SpinAndHold/SpinAndHold";
import { SlotBonus } from "../multigame/slot/Bonus/SlotBonus";
import { assertNotNullish } from "../multigame/debug";
import { TransitionFactoryPIXIAPP } from "../multigame/slot/Transition/TransitionFactoryPIXIAPP";
import { ITransitionParamsPIXIAPP } from "../multigame/slot/Transition/ITransitionFactoryPIXIAPP";
import { AwardJPShowPIXIAPPResponsive } from "../multigame/slot/Bonus/SpinAndHold/AwardJPShowPIXIAPPResponsive";
import { enterFullscreenIcon, exitFullscreenIcon, homeIcon } from "../multigame/svgicons";
import { AvailableGame } from "../multigame/MultigameAvailableGame";
import { IJackpotDisplayResponsive } from "../multigame/JackpotDisplay/IJackpotDisplayPIXIAPPResponsive";
import { GameEngineResponsive } from "../multigame/engine/GameEngineResponsive";
import { AwardJPShowNewLookPIXAPP } from "../multigame/slot/Bonus/SpinAndHold/AwardJPShowNewLookPIXIAPp";
// import { FountainAnimLevels } from "../multigame/slot/FountainAnimationPIXI";

function GameNameAlias(requestedGame: string): string {
	if (requestedGame == "RumAndGold") {
		return "GoldAndRum";
	}

	return requestedGame;
}


export type SinglegameGamesLoadedCallback = () => void;
export type SinglegameResourcesLoadedCallback = () => void;


// namespace for games
export namespace SlotGames {
}


export enum SinglegameState {
	Loading,
	Running
}

export type SinglegameUpdateDenomCallBack = (bets: BetConfig[], denom: number) => void;

export type SinglegameGameStateChangedCallback = (state: GameState) => void;

export class Singlegame_PIXIAPP implements IMultigame {
	//protected systemContext: ISystemContext = null;

	private clientState: ClientState = null;
	//public translation : Translator=null ;

	protected buttons: AvailableButton[] = [];

	private slotGame: SlotGameType1_ResponsivePIXIApp = null;

	// resources
	//protected resourceManager: ResourceManager = null;
	//protected resid: string = "MultigameContainer";
	protected resid: ResourceIdentifier = new ResourceIdentifier("Screen1", "Multigame");
	protected basepath: string = Settings.ResourcesFolder + "multigame/multigame/";


	protected logGroup: LogGroup = new LogGroup("Singlegame_PIXIAPP");
	protected singlegameView: HTMLElement = null;
	protected multigameViewBackground: HTMLElement = null;
	private gamesContainer: HTMLElement = null;
	private gamesMenuContainer: HTMLElement = null;
	private loadingContainer: HTMLElement = null;
	private progressPercent: HTMLElement;
	private progressDone: HTMLElement;
	private smoothLoadProgress: SmoothLoadProgress = null;
	private freeRoundsStats: FreeRoundsStats =
		{
			FreeRoundsBet: { InCents: 0 },
			FreeRoundsNumber: 0,
			PlayedFreeRoundsNumber: 0,
		}

	protected titleContainer: HTMLElement = null;
	private availableGames: Map<string, AvailableGame> = new Map<string, AvailableGame>();

	private allGames: HTMLElement = null;

	//private viewSize: Size = new Size(1280, 720);
	private body: HTMLElement = null;
	private viewSize: Size = new Size(Settings.ScreenWidth, Settings.ScreenHeight);
	//private multigameParams: MultigameParams = null;

	private resizeFitDelay: number = 200;
	private resizeFitTimer: number = 0;
	//private audio: AudioManager = null;
	//public screenScope: ScreenProtocolScope = new ScreenProtocolScope("multigame");
	//protected screenProtocol: ScreenProtocol = null;
	protected readyToHandleOtherScreens: boolean = false;

	protected loadErrorsContainer: HTMLElement = null;

	protected lock: Lock = null;
	//protected adminMenu: IMenu = null;
	//private gamesMenu: IGamesMenu = null;
	//public menuFactory : IGamesMenuFactory = new GamesMenuFactory();
	protected games: HTMLElement = null;
	protected stateMachine: StateMachine<SinglegameState> = null;

	//protected readonly returnToMenuMillis: number = Math.round(60 * 1000);
	//protected returnToMenuTimer: ITimeout;


	protected menuAudioInitialDelayTimer: ITimeout = null;
	protected menuAudioRepeatTimer: IInterval = null;

	protected readonly menuAudioInitialDelay: number = 3000;
	//protected readonly menuAudioRepeatDelay: number = 300000;
	protected readonly menuAudioRepeatDelay: number = 60 * 1000;

	//protected readonly defaultVolumeLevel: number = 2;
	protected robotPlay: RobotPlay = null;

	protected crashed: boolean = false;

	// protected resources: Resource[] = null;
	protected loadingFirstTime: boolean = true;

	//protected callAttendantMenu : CallAttendantMenu = null;

	//protected payoutMenu : PayoutMenu = null;

	protected loadingFinishedDelay: ITimeout;

	//protected backendSettings: BackendSettings;

	//protected gameFactory : CreateGameFactory = new CreateGameFactory();

	//add popupMessage 
	protected popupMessage: PopupMessage;

	protected screenProtocol: ScreenProtocol = null;

	public screenScope: ScreenProtocolScope = new ScreenProtocolScope("singlegame");

	protected jackpotDisplay: IJackpotDisplayResponsive = null;
	protected JackpotDisplayFactory: IJackpotDisplayFactory = new JackpotDisplayFactory();

	public constructor(
		protected systemContext: ISystemContext,
		protected resourceManager: ResourceManager,
		protected audio: AudioManager,
		protected apiConnection: HubConnection,
		protected api: SinglegameApi,
		protected backendSettings: IBackendSettingsService,
		protected translation: TranslationService,
		protected moneyFormatter: IMoneyFormatterService,
		protected speedManager: SpeedManager,
		protected fountainPIXI: FountainPIXI,
		protected gameEngineResponsive: GameEngineResponsive,
		protected sharedVideoContainer: SharedVideoContainer
	) {

		this.systemContext = systemContext.CreateSubContext("Multigame");

		this.pingTimer = this.systemContext.TimingContext().CreateInterval("pingTimer", 1000, () => this.SendPing());

		// if (Settings.screen3Display == Screen3SettingDisplay.JackpotDisplay) {
		// 	let params: JackpotDisplayParams = {
		// 		systemContext: this.systemContext,
		// 		resid: this.resid,
		// 		viewSize: this.viewSize,
		// 		screenProtocol: this.screenProtocol
		// 	};

		// 	jackpotDisplayGlobalResponsive = this.JackpotDisplayFactory.CreateNewJackpotDisplay(params);
		// 	params = null;
		// 	// jackpotDisplayGlobalResponsive = this.jackpotDisplay;
		// 	jackpotDisplayGlobalResponsive.View().style.zIndex = ZIndex.JPType.toString();
		// }
		//this.translation.LoadTranslation(SpanishTranslation);
		this.stateMachine = new StateMachine<SinglegameState>(SinglegameState.Loading, this.logGroup, (m) => SinglegameState[m])

		window.onerror = async (message, source, lineno, colno, error) => {
			this.crashed = true;

			this.lock?.StartFrontend("FrontendError", "FE");
			try {
				console.error("Frontend error (" + message + ":" + source + ":" + lineno + ":" + colno + " = " + error.message + ")", error);
				await api.frontendError(JSON.stringify(error, Object.getOwnPropertyNames(error)));
			}
			catch (ex) {
			}
		}

		document.documentElement.style.fontSize = Scale.fhpx(25);

		//this.protocol = protocol;

		this.clientState = new ClientState();
		service.onlineApi = this.api


		//this.clientState.UpdateBalance(10000000);

		// 
		//this.resourceManager = new ResourceManager(this.logGroup);
		this.resourceManager = resourceManager;
		//this.resourceManager.AddLoadProgressCallback((percent: number) => this.LoadProgress(percent));
		//this.resourceManager.AddLoadFinishedCallback(() => this.LoadFinished());
		// let globalLoadCoordinator: GlobalLoadCoordinator = GlobalLoadCoordinator.Instance;

		// globalLoadCoordinator.Add(this.resourceManager);
		// globalLoadCoordinator.AddOnGlobalProgress((percent: number) => this.LoadProgress(percent));
		// globalLoadCoordinator.AddOnGlobalFinished(() => this.LoadFinished());
		// globalLoadCoordinator.AddOnGlobalError((failed: Resource[]) => this.LoadFailed(failed));

		this.multigameViewBackground = CreateElement("div", {
			classes: ["multigameViewBackground", this.resid.Scope()],
			parentToAppend: document.body,
			style: {
				width: "100%",
				height: "100%",
				position: "absolute",
				backgroundSize: "cover",
				backgroundRepeat: "no-repeat",
				backgroundPosition: "center",
				overflow: "hidden",
				display: "flex",
				alignItems: "center",
				justifyContent: "center"
			}
		});
		this.singlegameView = CreateElement("div", {
			classes: ["singlegame", this.resid.Scope()],
			parentToAppend: this.multigameViewBackground,
			style: {
				width: "100%",
				height: "100%",
				position: "relative",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				backgroundSize: "cover",
			}
		});

		this.singlegameView.appendChild(this.sharedVideoContainer.View());

		//this.multigameView.style.margin = "-1px 0px"; // when stretching, background goes 
		// let gameName = GameNameAlias(SearchParam("gameName") ?? SearchParam("gameCode"));
		// let gameBasePath = `${Settings.ResourcesFolder}multigame/slot/${gameName}/`;
		// let backgroundPath = `${gameBasePath}resources/background${Settings.Screens}S/background.png` + ;
		let logoPath = `${Settings.ResourcesFolder}singlegame/BarProgress/Dixpa_logo.png`;

		this.loadingContainer = document.createElement("div");
		this.loadingContainer = CreateElement("div", {
			classes: ["loading"],
			parentToAppend: this.multigameViewBackground,
			style: {
				fontSize: Scale.Hpx(40),
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexDirection: "column",
				width: "100%",
				height: "100%",
				//zIndex : ZIndex.ElementsMenu.toString(),
				position: "absolute",
				//backgroundImage: `url(${backgroundPath})`,
				backgroundSize: "cover",
				backgroundPosition: "center"
			}
		});

		this.titleContainer = CreateElement("div", {
			parentToAppend: this.loadingContainer,
			style: {
				// backgroundImage: `url(${gameBasePath}resources/title.png)`,
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundPosition: "center",
				width: "100%",
				maxWidth: "640px",
				height: "360px",
				//border: "1px solid red"
			}
		});


		let progressBar = CreateElement("div", {
			parentToAppend: this.loadingContainer,
			style: {
				//border: "1px solid red",
				position: "relative",
				width: "60vw",
				height: "1.5em",
				minHeight: "1.25em",
				borderRadius: "9999px",
				backgroundColor: "black",
				overflow: "hidden",
				border: "3px solid blue"
			}
		});

		const branding = GetUrlParamString("branding", "dixpa").toLowerCase();

		// no branding
		if (branding == "unbranded") {
		}
		// dixpa branding
		else if (branding == "dixpa") {
			let logoContainer = CreateElement("div", {
				parentToAppend: this.loadingContainer,
				style: {
					display: "flex",
					width: "640px",
					height: "360px",
					justifyContent: "center",
					alignItems: "center"
					//border: "1px solid red"
				}
			});

			let logo = CreateElement("div", {
				parentToAppend: logoContainer,
				style: {
					//border: "1px solid red",
					position: "relative",
					width: Scale.Wpx(240),
					height: Scale.Hpx(75),
					//borderRadius: "9999px",
					backgroundImage: `url(${logoPath})`,
					backgroundSize: "cover",
					backgroundPosition: "center"

				}
			});
		}


		let progressDoneWrapper = CreateElement("div", {
			parentToAppend: progressBar,
			style: {
				position: "absolute",
				inset: "3px",
			}
		});

		this.progressDone = CreateElement("div", {
			parentToAppend: progressDoneWrapper,
			style: {
				///border: "1px solid green",
				width: "0%",
				height: "100%",
				borderRadius: "9999px",
				backgroundColor: "blue",
				boxSizing: "border-box",
			}
		});

		this.progressPercent = CreateElement("div", {
			parentToAppend: progressBar,
			style: {
				width: "100%",
				height: "100%",
				position: "absolute",
				top: "0px",
				left: "0px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				color: "white",
			},
			innerHTML: "Connecting..."
		});



		//this.audio = new AudioManager(this.resid);

		this.screenProtocol = new ScreenProtocol("1");
		this.screenProtocol.SetKeepAlive(500);

		this.screenProtocol.AddReceiveMessageHandler(ScreenIntroductionMessage.msgname, (message) => this.OnScreenConnected(<ScreenIntroductionMessage>message), this.screenProtocol.Scope());
		this.screenProtocol.Connect();


		// main screen has just reloaded, force other screens to reload
		this.screenProtocol.Send(new ScreenReloadMessage(), this.screenScope);

		// this.screenProtocol = new ScreenProtocol("1");
		// this.screenProtocol.SetKeepAlive(500);

		//this.screenProtocol.AddReceiveMessageHandler(ScreenIntroductionMessage.msgname, (message) => this.OnScreenConnected(<ScreenIntroductionMessage>message), this.screenProtocol.Scope());
		//this.screenProtocol.Connect();
		//this.translation=this.screenProtocol.translation;
		//this.screenProtocol.settranslot(this.translation);
		//service.translator = this.translation;



		// main screen has just reloaded, force other screens to reload
		//this.screenProtocol.Send(new ScreenReloadMessage(), this.screenScope);

		this.robotPlay = new RobotPlay(this.systemContext, this.clientState, this.availableGames);
		// service.robotPlay = this.robotPlay;
		// service.moneyFormatter = this.moneyFormatter;



		this.lock = new Lock(this.resid, this.basepath);

		//add popupMessage 
		this.popupMessage = new PopupMessage(this.resid, this.basepath, this.systemContext);


		// let gamesMenuParams : IGamesMenuParams = { 
		// 	systemContext:this.systemContext,
		// 	logGroup:this.logGroup, 
		// 	resid:this.resid, 
		// 	availableGames:this.availableGames, 
		// 	viewSize:this.viewSize, 
		// 	slotGames:this.slotGames, 
		// 	translator:this.translation, 
		// 	clientState:this.clientState, 
		// 	moneyFormatter:this.moneyFormatter, 
		// 	audio:this.audio
		// }

		// this.gamesMenu = this.menuFactory.CreateGamesMenu(gamesMenuParams);
		// this.gamesMenu.GameSelectedCallback((gameName: string) => this.GameSelect(gameName));

		//this.robotPlay.GameSelectedCallback((gameName: string)=> this.GameSelect(gameName));

		//this.robotPlay.GameExitCallback(()=> protocol.RequestGameExit());

		this.ProtocolSetup();

		// when language changes...
		// this.translation.SetOnLanguageChangedCallback((t: Translation) => {
		// 	// send message to other screens
		// 	this.screenProtocol.Send(new ScreenLanguageSelectedMessage(t.locality), this.screenScope);
		// });

		// play first sound with smaller delay
		this.menuAudioInitialDelayTimer = this.systemContext.TimingContext().CreateTimeout("menuAudioInitialDelayTimer", 3000, () => {
			this.menuAudioRepeatTimer.Restart();
			this.PlayMenuAudio();
		});

		// repeat the sound with larger delay
		this.menuAudioRepeatTimer = this.systemContext.TimingContext().CreateInterval("menuAudioRepeatDelayTimer", 60 * 1000, () => this.PlayMenuAudio());

		this.loadingFinishedDelay = this.systemContext.TimingContext().CreateTimeout("loadingFinishedDelay", 500, async () => {
			this.stateMachine.ChangeState(SinglegameState.Running);
			// await this.FrontendLoaded();
		});


		// this.returnToMenuTimer = this.systemContext.TimingContext().CreateInterval("returnToMenuTimer", 60 * 1000, () => {

		// 	Log.Debug(this.logGroup, "Triggered ReturnToMenu timer");

		// 	this.SelectMinimumBets();

		// 	// exit game if not dummy menu
		// 	if (this.slotGame && Settings.MenuType != MenuType.DummyMenu)
		// 	{
		// 		this.slotGame.GamesMenu()
		// 	}


		// 	// FIXME is this necessary here?
		// 	// change to default language
		// 	if (Settings.LangugeInit == LanguageInit.SpanishTranslation) {
		// 		this.translation.ChangeLanguage(SpanishTranslation.locality);
		// 	}
		// 	else if (Settings.LangugeInit == LanguageInit.EnglishTranslation) {
		// 		this.translation.ChangeLanguage(EnglishTranslation.locality);
		// 	}

		// 	this.audio.SetVolume(this.backendSettings.GetNum("system.defaultVolume", 2));
		// });

		service.translator = this.translation;


		this.autoFitTimeout = this.systemContext.TimingContext().CreateInterval("autoFitDelay", 250, () => {
			//FitScreen(GetFitType());
		});


		this.apiReconnectTimeout = this.systemContext.TimingContext().CreateTimeout("apiReconnectTimeout", 1000, () => this.ApiConnect());

		this.apiConnection.onclose(this.OnApiDisconnected.bind(this));


		void this.ApiConnect();


	}
	async SetLoadInfo(loadInfo: LoadInfo): Promise<void> {
		// throw new Error("Method not implemented.");
	}

	protected OnScreenConnected(message: ScreenIntroductionMessage): void {
		//if (message.to == ScreenProtocolDestination.Broadcast) {}

		if (this.readyToHandleOtherScreens) {
			this.SynhronizeScreen(new ScreenProtocolDestination(message.from));
		}
		// else {
		// 	this.screensToSynchronize = true;
		// }
	}

	protected SynhronizeScreen(screen: ScreenProtocolDestination) {

		// step 1 send machine info
		// this.screenProtocol.Send(new ScreenLoadInfoMessage(this.machineInfo), this.screenScope, screen);

		// step 2 send initial game info for each game
		// this.initData.forEach((initData) => {
		// 	this.screenProtocol.Send(new ScreenGameInitDataMessage(initData), this.screenScope, screen);
		// });

		this.screenProtocol.Send(new ScreenGameInitDataMessage(this.slotGame.InitData), this.screenScope, screen)
		// step 3 sync multigame
		// this.screenProtocol.Send(new ScreenMultigameSyncMessage(this.slotGameName, this.slotGameInMenu), this.screenScope, screen);

		// step 4 sync selected game
		// TODO
	}


	protected async ApiConnect() {

		try {
			Log.Debug("API", "Connecting");

			await this.apiConnection.start();
		}
		catch (ex) {
			// Log.Debug("API", "Connecting failed", ex);
			console.error(new Error(`API connection failed`));
			console.error(ex);

			this.ApiReconnect();
			return;
		}


		try {
			await this.OnApiConnected();
		}
		catch (exOnConnected) {
			console.error(new Error("OnApiConnected callback failed"));
			console.error(exOnConnected);
		}
	}


	protected apiReconnectTimeout: ITimeout;
	protected ApiReconnect() {
		Log.Debug("API", "Reconnecting in 1000");
		this.apiReconnectTimeout.Restart();
	}

	protected async OnApiConnected() {
		Log.Debug("API", "Connecting success");
		this.pingTimer.Restart();
		await this.LoadGames();
	}

	protected async AuthenticateApi() {
		Log.Debug("API", "Authenticate");
	}

	protected OnApiDisconnected(error?: Error) {
		Log.Debug("API", "Disconnected", error);
		this.pingTimer.Stop();
		this.ApiReconnect();
	}

	//protected fittype: FitType;
	protected autoFitTimeout: IInterval;

	public ViewReady(): void {
		// FitScreen(GetFitType());

		if (Settings.EndlessFitting) {
			// fit everytime when resizing
			window.addEventListener("resize", () => {
				this.autoFitTimeout.Restart();
			});
		}
	}


	protected ProtocolSetup(): void {
		// TODO?
	}

	// step 3, 4, 5
	protected loadResponse: ApiResultOfLoadResponseDTO = null;
	protected sessionToken: string = null;
	protected currentBetIndex: number = 0;
	protected result: SpinResult = null;
	// private freeRoundsMessageShowed: boolean = false;
	protected async LoadGames() {

		Log.Debug(this.logGroup, "Load games");
		this.awardJPDebugShow = new AwardJPShowNewLookPIXAPP();

		const loadRequestDto: LoadRequestDTO = {
			IsReal: SearchParamBool("isReal"),
			Token: SearchParam("token"),
			GameName: GameNameAlias(SearchParam("gameName") ?? SearchParam("gameCode")),
			ExtraData: SearchParam("extraData"),
			HomeUrl: SearchParam("homeUrl"),
			LanguageCode: SearchParam("languageCode"),
			CashierUrl: SearchParam("cashierUrl"),
			CurrencyCode: SearchParam("currencyCode"),
			HistoryUrl: SearchParam("historyUrl"),
			LoggedInTime: SearchParamNum("loggedInTime"),
			RealityCheckTimeout: SearchParamNum("RealityCheckTimeout"),
			RegulationLimits: SearchParam("RegulationLimits"),
			RegulationSelfExclusion: SearchParam("RegulationSelfExclusion"),
			RegulationSelfTest: SearchParam("RegulationSelfTest"),

			BetIndex: this.currentBetIndex
		};

		this.popupMessage.SetHomeUrl(loadRequestDto.HomeUrl);
		this.popupMessage.SetCashierUrl(loadRequestDto.CashierUrl);
		this.popupMessage.SetHistoryUrl(loadRequestDto.HistoryUrl);

		let loadResponse: ApiResultOfLoadResponseDTO;
		try {
			loadResponse = await this.api.load(loadRequestDto);
		}
		catch (error) {
			this.smoothLoadProgress?.Stop();
			this.progressPercent.innerText = "Load failed";
			throw error;
		}


		if (loadResponse.ResultStatus != ResultStatus.Success) {
			// ErrorLoadingGames();

			Log.Error(this.logGroup, `/load error: ${loadResponse.ErrorMessage}`);
			this.smoothLoadProgress?.Stop();
			this.progressPercent.innerText = "No such game";
			return;
		}


		// update settings if exists
		const onlineParams = loadResponse.Data.GameConfig.Meta.onlineParams;
		if (onlineParams && onlineParams.settings) {
			await ChangeSettings(onlineParams.settings);
		}

		// console.log("Selected Settings: ", Settings.SettingsName);
		this.popupMessage.SetHomeUrl(loadRequestDto.HomeUrl);
		this.popupMessage.SetCashierUrl(loadRequestDto.CashierUrl);
		this.popupMessage.SetHistoryUrl(loadRequestDto.HistoryUrl);

		// if games have changed, force reload
		if (this.loadResponse) {
			// if game config was changed, then we need to reload (do we really need to reload?)
			if (JSON.stringify(loadResponse.Data.GameConfig) == JSON.stringify(this.loadResponse.Data.GameConfig)
			) {
				// already loaded, don't need to reload
				Log.Debug(this.logGroup, "LoadGames() games already loaded");

				this.loadResponse = loadResponse;
				this.sessionToken = loadResponse.Data.SessionToken;
				return;
			}
			else {
				window.location.reload();
			}
		}



		// fresh load
		else {
			if (loadResponse.Data.Language) {
				await service.translator.ChangeLanguage(loadResponse.Data.Language);
			}

			if (loadResponse.Data.Currency) {
				service.moneyFormatter.SetCurrency(loadResponse.Data.Currency);
			}

			const jackpotRequired = loadResponse.Data.GameConfig.JackpotEnabled;

			// construct jackpot only when the loaded game really has jackpot support
			if (jackpotRequired && Settings.screen3Display == Screen3SettingDisplay.JackpotDisplay) {
				let params: JackpotDisplayParams = {
					systemContext: this.systemContext,
					resid: this.resid,
					viewSize: this.viewSize,
					screenProtocol: this.screenProtocol,
					gameName: onlineParams.original,
				};

				this.jackpotDisplay = await this.JackpotDisplayFactory.CreateNewJackpotDisplayResponsive(params);
				params = null;

					this.jackpotDisplay.OnUpdateAppCallback = () => {
						const appView = this.gameEngineResponsive?.GetAppView?.();
						appView?.ticker?.update(0);
					}
				// globalThis.jackpotDisplayGlobalResponsive = this.jackpotDisplay;
			}

			if (Settings.OnlineControls) {

				let containerfullscreen = CreateElement("div", {
					classes: ["containerfullscreen"],
					parentToAppend: this.multigameViewBackground,
					style: {
						top: "0px",
						left: "0px",
						width: "100%",
						height: "25%%",
						//position: "relative",
						position: "absolute",
						zIndex: ZIndex.FullScreen.toString(),
					},
				});

				if (document.fullscreenEnabled) {
					let isFullscreen: boolean = false;
					let fullscreen = CreateElement("div", {
						classes: ["fullscreen"],
						innerHTML: enterFullscreenIcon,
						parentToAppend: containerfullscreen,
						style: {
							borderRadius: "0.5em",
							width: "4%",
							height: "4%",
							padding: "0.4em",
							margin: "0.4em 0em 0em 0.4em",
							background: "rgba(255, 255, 255, 0.5)",
							display: "flex"
						},
						mousedown: () => {
							console.log("Toggle fullscreen");



							if (!document.fullscreenElement) {
								document.body.requestFullscreen()
									.then(() => {
										fullscreen.innerHTML = exitFullscreenIcon;
									})
									.catch(err => {
										alert(`Error attempting to enter full-screen mode: ${err.message} (${err.name})`);
									});
							} else {
								document.exitFullscreen()
									.then(() => {
										fullscreen.innerHTML = enterFullscreenIcon;
									})
									.catch(err => {
										alert(`Error attempting to exit full-screen mode: ${err.message} (${err.name})`);
									});
							}
						}
					});
				}
				else {
					console.warn("Fullscreen mode is not available");
				}

				// let homeUrl: URL | null = null;
				// try
				// {
				const homeUrl = loadRequestDto.HomeUrl;
				// }
				// catch (ex)
				// {
				//   console.log("Home url is not valid", ex);
				// }

				if (homeUrl) {
					let containerHome = CreateElement("div", {
						classes: ["containerHomebtn"],
						parentToAppend: this.multigameViewBackground,
						style: {
							top: "0px",
							width: "100%",
							height: "25%%",
							//position: "relative",
							position: "absolute",
							zIndex: ZIndex.FullScreen.toString(),
						},
					});
					let home = CreateElement("div", {
						classes: ["home"],
						innerHTML: homeIcon,
						parentToAppend: containerHome,
						style: {
							position: "absolute",
							borderRadius: "0.5em",
							width: "4%",
							// height: "4%",
							padding: "0.4em",
							margin: "0.4em 0em 0em 0.4em",
							background: "rgba(255, 255, 255, 0.5)",
							display: "flex",
							right: "0px",
						},
						mousedown: () => {
							console.log("Go to home");

							// find if url contains parameter "naviage"
							// if yes, remove it, but keep the rest of parameters
							let url = homeUrl.toString();
							if (url.includes("#navigate")) {
								const navigateUrl = url.toString();
								window.parent.postMessage({ type: "navigate", url: navigateUrl }, "*");
							}
							else {
								window.location.href = homeUrl.toString();
							}
						}
					});
				}

			}
		}

		this.loadResponse = loadResponse;
		this.sessionToken = loadResponse.Data.SessionToken;

		this.clientState.UpdateBalance(loadResponse.Data.Balance.InCents);


		this.ApplyFirstCashin();


		// this.availableGame = loadResponse.Data.GameConfigs;

		// //this.screenProtocol.Send(new LoadInfoGames(loadInfo),this.screenScope);

		// this.availableGames.clear();


		// loadInfo.Games.forEach(g => this.availableGames.set(g.Name, {
		// 	Enabled: true,
		// 	Index: g.Index,
		// 	Name: g.Name
		// }));

		// this.initData.clear();
		// loadInfo.Games.forEach(g => this.initData.set(g.Name, g as SlotGameInitData));

		let jackpotRequired: boolean = loadResponse.Data.GameConfig.JackpotEnabled;

		if (jackpotRequired) {
			this.api.registerOperation("JackpotValuesUpdate", this.resid.ID(), (data) => {
				const values = Object.values(data.JackpotValues)
				this.slotGame.OnJackpotValues(values)
			});
		}

		// para DoubleUp solo usamos LoadResponseDTO no usanos settings y obtenemos AllowDoubleUp del appsettings.json
		const data = loadResponse.Data;
		const doubleupConfig = (data?.AllowDoubleUp && data?.doubleupConfig)
			? data.doubleupConfig
			: null;

		this.gameEngineResponsive = new GameEngineResponsive(this.resid, this.systemContext);
		(globalThis as unknown as { gameViewAppPixiResponsive?: GameEngineResponsive }).gameViewAppPixiResponsive =
			this.gameEngineResponsive;

		const multigameParams: MultigameParams = {
			systemContext: this.systemContext,
			resid: this.resid,
			viewSize: this.viewSize,
			clientState: this.clientState,
			screenProtocol: this.screenProtocol,
			translator: this.translation,
			robotPlay: this.robotPlay,
			backendSettings: this.backendSettings,
			audio: this.audio,
			jackpotRequired: jackpotRequired,
			doubleupConfig,
			speedManager: this.speedManager,
			loadRequest: loadRequestDto,
			jackpotDisplay: jackpotRequired ? this.jackpotDisplay : null,
			gameEngineResponsive: this.gameEngineResponsive,
		};


		// construct one game

		const gameName = loadResponse.Data.GameConfig.Meta.onlineParams?.original ?? loadResponse.Data.GameConfig.Meta.GameName;

		const game = await this.ConstructGame(gameName, multigameParams, loadResponse.Data.GameConfig) as SlotGameType1_ResponsivePIXIApp;

		this.gameEngineResponsive.OnCreatedCallback = async () => {
			await game.OnCreateEngine();
			if (Settings.JackpotDisplayType == JackpotDisplayType.MysticPortalResponsive) {
				await this.jackpotDisplay?.CreateOnlyJackpot(this.gameEngineResponsive.GetViewJackpot());
			}
			else {
				await this.jackpotDisplay?.Create(this.gameEngineResponsive.GetViewJackpot());
			}
			this.jackpotDisplay?.OnResize();
		}

		this.gameEngineResponsive.OnDestroyCallback = () => {
			delete (globalThis as unknown as { gameViewAppPixiResponsive?: GameEngineResponsive }).gameViewAppPixiResponsive;
			game.OnDestroyEngine();
			if (Settings.JackpotDisplayType == JackpotDisplayType.MysticPortalResponsive) {
				this.jackpotDisplay?.DestroyWhitOutAPP();
			}
			else {
				this.jackpotDisplay?.Destroy();
			}
		}

		game.CollectGarbage = () => {
			this.gameEngineResponsive.CollecGarbage();
		}
		// let popUpMessageCounter = 0;
		game.showFreeRoundsPopUpCallBack = (freeRoundsStats: FreeRoundsStats) => {
			const normalizedCurrent: FreeRoundsStats = {
				FreeRoundsNumber: this.freeRoundsStats?.FreeRoundsNumber ?? 0,
				PlayedFreeRoundsNumber: this.freeRoundsStats?.PlayedFreeRoundsNumber ?? 0,
				FreeRoundsBet: this.freeRoundsStats?.FreeRoundsBet ?? { InCents: 0 },
			};
			const normalizedIncoming: FreeRoundsStats = {
				FreeRoundsNumber: freeRoundsStats?.FreeRoundsNumber ?? 0,
				PlayedFreeRoundsNumber: freeRoundsStats?.PlayedFreeRoundsNumber ?? 0,
				FreeRoundsBet: freeRoundsStats?.FreeRoundsBet ?? { InCents: 0 },
			};

			const remainingOld = normalizedCurrent.FreeRoundsNumber - normalizedCurrent.PlayedFreeRoundsNumber;
			const remaingingNew = normalizedIncoming.FreeRoundsNumber - normalizedIncoming.PlayedFreeRoundsNumber;

			const betChanged = normalizedCurrent.FreeRoundsBet.InCents !== normalizedIncoming.FreeRoundsBet.InCents;

			this.freeRoundsStats = normalizedIncoming;

			if (remaingingNew > remainingOld && this.freeRoundsStats.FreeRoundsNumber > 0
				|| betChanged) {
				this.ShowFreeRoundsPopup();
			}

			this.UpdateFreeRoundsStats();
		}

		this.robotPlay.GameSelectedCallback(() => {
			this.robotPlay.OnGameSelected(game);
			setTimeout(() => {
				this.slotGame.SelectBet2(this.slotGame.selectedBetIndex.Index);
			}, 500);
		});
		// loading container update
		let gameBasePath = `${Settings.ResourcesFolder}multigame/slot/${gameName}/`;
		const backgroundFile = Settings.Enable2plus1 ? "background2plus1.png" : "background.png";
		let backgroundPath = `${gameBasePath}resources/background${Settings.Screens}S/${backgroundFile}`;
		// Paint shell background under the loader so it is already decoded when the loader hides.
		this.multigameViewBackground.style.backgroundImage = `url(${backgroundPath})`;
		this.loadingContainer.style.backgroundImage = `url(${backgroundPath})`;
		this.titleContainer.style.backgroundImage = `url(${gameBasePath}resources/title.png`;
		//

		let parentSpinError = game.SpinError.bind(game);


		game.SpinError = async (message: string, spinResponse?: SpinSuccess) => {

			parentSpinError(message, spinResponse);



			// if (previousSpin)
			// {
			// 	this.ErrorPopUpMessage.Stop();
			// }
			// else
			// {
			// 	this.showNoCreditTimeout.Start();
			// }


			this.popupMessage.ShowPopupMessage({
				// ...resultCast.ErrorMessage as any as IPopupMessage,
				Title: "Error",
				Text: message,
				DisplayType: DisplayType.PopUp,
				Buttons: [
					{
						Text: "OK",
						Action: "continue",
						Link: null,
						LinkType: LinkType.Disable,
					}
				]
			});
		};

		game.ActualSpin = async (betRequest: BetRequest) => {

			game.gameStartTimeout.Start();
			try {

				this.result = await this.api.spin({
					SessionToken: this.sessionToken,
					Request: {
						BetIndex: betRequest.Index,
						betType: betRequest.Type
					}
				});
			}
			catch (e) {
				//console.log(e);
				this.result = {
					Data: null,
					PlayerMessage: null,
					ErrorMessage: "Connection Lost",
					ResultStatus: ResultStatus.Error
				}
			}
			finally {
				game.gameStartTimeout.Stop();
			}

			if (game.stateMachine.State() != "WaitGameStart") {
				// game moved on, nothing to do
				await game.SpinError("Game timeouted"/*, result*/);
				return;
			}

			if (this.result.ResultStatus == ResultStatus.Success) {
				await game.SpinSuccess(this.result.Data);
				this.freeRoundsStats =
				{
					FreeRoundsBet: this.result.Data.FreeRoundsBet,
					FreeRoundsNumber: this.result.Data.FreeRoundsNumber,
					PlayedFreeRoundsNumber: this.result.Data.PlayedFreeRoundsNumber
				}
				this.UpdateFreeRoundsStats();
			}
			else {
				await game.SpinError(this.result.ErrorMessage);
			}

		};

		game.OnBetChanged = async (betIndex: number) => {
			this.currentBetIndex = betIndex;
			await this.api?.betChanged({
				SessionToken: this.sessionToken,
				Request: {
					BetIndex: betIndex
				}
			});
		};

		this.slotGame = game;

		//setTimeout(() => this.clientState.UpdateBalance(loadResponse.Data.Balance.InCents), 1000);

		//this.PrepareResources();

		for (let loadingStage of LoadingStageOrder) {
			console.log(`Loading stage: ${loadingStage}`);
			this.resourceManager.SetLoadingStage(loadingStage);

			console.log(`Preparing resources stage: ${loadingStage}`);
			// for (let m of multigames)
			// {
			this.audio.allowAdd = true;
			await this.PrepareResources(loadingStage, this.resourceManager);
			this.audio.allowAdd = false;
			// }


			console.log(`Sending resources list to backend`);
			{
				// let resourcesThisStage = resourceManager.GetResourcesCurrentStage();
				// await ReportResources(resourcesThisStage);

				let resources = this.resourceManager.GetResources();
				//await ReportResources(resources);
			}

			console.log(`Finished preparing resources stage: ${loadingStage}`);


			// {
			//     console.log(`Waiting for more promises to resolve: ${loadingStage}`);
			//     let resources1 = [...resourceManager.Resources()];
			//     await Delay(10000);
			//     let resources2 = [...resourceManager.Resources()];

			//     if (resources1.length != resources2.length)
			//     {
			//         let newResources = resources2.slice(resources1.length);
			//         console.log("New resources after prepare, missing async/await?: ", newResources);
			//         throw "New resources after prepare";
			//     }
			// }



			console.log(`Loading resources stage: ${loadingStage}`);
			try {
				let loadPromise = this.resourceManager.LoadStage(loadingStage);
				await loadPromise;
			}
			catch (e) {
				console.log("Exception loading resources", e);
				throw e;
			}


			let allLoaded = this.resourceManager.EnsureAllLoaded();
			if (!allLoaded) {
				throw "Resource manager finished loading, but not all resources are processed?";
			}


			let failedResources = this.resourceManager.FailedResources();
			if (failedResources.length > 0) {
				//console.log(`Some resources failed to load stage: ${loadingStage}`, failedResources);
				// for (let m of multigames)
				// {
				await this.resourceManager.AllowGet(async () => {
					await this.LoadFailed(loadingStage, failedResources);
				});
				// }

				// return;
			}

			console.log(`Resources loaded stage: ${loadingStage}`);
			// for (let m of multigames)
			// {
			await this.resourceManager.AllowGet(async () => {
				await this.ResourcesLoaded(loadingStage, this.resourceManager);
			});
			// }
		}

	}

	// private UpdateFreeRoundsSpin() {

	// 	this.freeRoundsStats =
	// 	{
	// 		...this.freeRoundsStats,
	// 		FreeRoundsNumber: this.freeRoundsStats.FreeRoundsNumber - 1,
	// 	}
	// 	if (this.result.Data.FreeRoundsNumber == this.result.Data.PlayedFreeRoundsNumber && this.freeRoundsStats.FreeRoundsNumber > 0) return;

	// 	this.UpdateFreeRoundsStats();
	// }

	private UpdateFreeRoundsStats() {

		this.slotGame.panel.SetFreeRoundsStats(this.freeRoundsStats);
		this.FreeRoundsAvailable(this.freeRoundsStats.FreeRoundsNumber, this.freeRoundsStats.PlayedFreeRoundsNumber);

		const freeRoundsRem =
			this.freeRoundsStats.FreeRoundsNumber > this.freeRoundsStats.PlayedFreeRoundsNumber &&
			this.freeRoundsStats.FreeRoundsBet.InCents == this.slotGame.GetSelectedBet().TotalBetCents.InCents;

		this.clientState.CheckFreeRounds(freeRoundsRem);
		// // this.freeRoundsStats = freeRoundsInfo;		

		// // if (!this.FreeRoundsAvailable(this.freeRoundsStats.FreeRoundsNumber, this.freeRoundsStats.PlayedFreeRoundsNumber))
		// // 	{
		// // 		this.responsiveFreeRoundsContainer.style.visibility = "hidden";
		// // 		return;
		// // 	}
		// if (freeRoundsRem || this.freeRoundsStats.FreeRoundsBet.InCents !== this.slotGame.GetSelectedBet().TotalBetCents.InCents){
		// 	this.responsiveFreeRoundsContainer.style.visibility = "hidden";
		// 	this.clientState.CheckFreeRounds(false);
		// 	return;
		// }



		//this.clientState.CheckFreeRounds(freeRoundsRem);
		// this.responsiveFreeRoundsContainer.style.visibility = "visible";
		// this.freeRoundsCounter.innerHTML = this.translation.Translate(() => this.translation.t.freerRoundCounterText(this.loadResponse.Data.FreeRoundsStats.FreeRoundsNumber - this.freeRoundsStats.PlayedFreeRoundsNumber)).translation();

	}

	protected async ConstructGame(name: string, multigameParams: MultigameParams, initData: SimpleSlotGameConfiguration): Promise<SlotGame> {
		const gameFactory: IGameFactory = CreateGameFactory.Instance.GetFactory(name);
		const game: SlotGame = await gameFactory.CreateGame_ResponsivePIXIAPP(multigameParams, initData as SlotGameInitData, this.gameEngineResponsive);

		this.availableGames.set(name, {
			Index: 0,
			Name: name,
			Enabled: true,
			Order: 0
		});

		return game;
	}

	protected loadTimer: number = -1;

	// protected jackpotDisplay: IJackpotDisplay = null;
	private awardJPDebugShow: AwardJPShowNewLookPIXAPP = null;


	public async PrepareResources(loadingStage: LoadingStage, resourceManager: ResourceManager): Promise<void> {

		if (loadingStage == LoadingStage.System) {
			await this.PrepareResourcesSystem(loadingStage, resourceManager);
		}
		else {
			await this.PrepareResourcesGames(loadingStage, resourceManager);
		}
		// else if (loadingStage == LoadingStage.GamesConfig)
		// 	await this.PrepareResourcesGames(loadingStage, resourceManager);

		// if (loadingStage == LoadingStage.GamesPreload)
		// 	await this.PrepareResourcesGames(loadingStage, resourceManager);

		// if (loadingStage == LoadingStage.Games) {

		// 	await this.PrepareResourcesGames(loadingStage, resourceManager);

		// }
	}

	protected async PrepareResourcesSystem(loadingStage: LoadingStage, resourceManager: ResourceManager): Promise<void> {
		// main screen now has all the data needed, other screens can be synchronized
		this.readyToHandleOtherScreens = true;

		resourceManager.Add(new CSSResource(Settings.ResourcesFolder + "multigame/slot/common/SpinnableReels.css", "SpinnableReels", this.resid.Add("SpinnableReelsStyle")));
		this.lock.PrepareResources(resourceManager);

		let gameName = this.loadResponse.Data.GameConfig.Meta.onlineParams.original;
		let gameBasePath = Settings.ResourcesFolder + "multigame/slot/" + gameName + "/";
		const backgroundFile = Settings.Enable2plus1 ? "background2plus1.png" : "background.png";
		resourceManager.Add(new ImageResource(gameBasePath + "resources/background" + Settings.Screens + "S/" + backgroundFile, this.resid.ScopedResourceName([gameName, "background" + Settings.Screens + "S"])));

		// create attendant menu
		let paramsCallAttendantMenu: ICallAttendanMenuParams = {
			resid: this.resid,
			basePath: this.basepath,
			//translator : this.translator,
			//elem : this.panel.View().querySelector(".but-attendant"),
			systemContext: this.systemContext
		}

		// load fonts
		let notoSansDisplay: { fileName: string, fontName: string }[] = [
			{ fileName: "NotoSansDisplay-Black", fontName: "Default-Black" },
			//{fileName: "NotoSansDisplay-BlackItalic", fontName: "Default-BlackItalic"},
			{ fileName: "NotoSansDisplay-Bold", fontName: "Default-Bold" },
			{ fileName: "NotoSansDisplay-BoldItalic", fontName: "Default-BoldItalic" },
			{ fileName: "NotoSansDisplay-ExtraBold", fontName: "Default-ExtraBold" },
			//{fileName: "NotoSansDisplay-ExtraBoldItalic", fontName: "Default-ExtraBoldItalic"},
			//{fileName: "NotoSansDisplay-ExtraLight", fontName: "Default-ExtraLight"},
			//{fileName: "NotoSansDisplay-ExtraLightItalic", fontName: "Default-ExtraLightItalic"},
			//{fileName: "NotoSansDisplay-Italic", fontName: "Default-Italic"},
			//{fileName: "NotoSansDisplay-Light", fontName: "Default-Light"},
			//{fileName: "NotoSansDisplay-LightItalic", fontName: "Default-LightItalic"},
			//{fileName: "NotoSansDisplay-Medium", fontName: "Default-Medium"},
			//{fileName: "NotoSansDisplay-MediumItalic", fontName: "Default-MediumItalic"},
			{ fileName: "NotoSansDisplay-Regular", fontName: "Default-Regular" },
			{ fileName: "NotoSansDisplay-SemiBold", fontName: "Default-SemiBold" },
			//{fileName: "NotoSansDisplay-SemiBoldItalic", fontName: "Default-SemiBoldItalic"},
			//{fileName: "NotoSansDisplay-Thin", fontName: "Default-Thin"},
			//{fileName: "NotoSansDisplay-ThinItalic", fontName: "Default-ThinItalic"}
		];

		for (let i = 0; i < notoSansDisplay.length; i++) {
			resourceManager.AddGlobal(new FontResource(this.basepath + "fonts/Noto/NotoSansDisplay-normal/" + notoSansDisplay[i].fileName + ".ttf", notoSansDisplay[i].fileName));
		}

		// set default font before loading others
		let defFontStyle: HTMLElement = document.createElement("style");
		defFontStyle.innerHTML = "html {font-family: 'NotoSansDisplay-Regular'}";
		document.querySelector("head").appendChild(defFontStyle);

		this.audio.AddTrack(new Track(this.basepath + "tracks/menuenter" + Settings.audioFormat, "menuenter"));
		this.audio.AddTrack(new Track(this.basepath + "tracks/menuleave" + Settings.audioFormat, "menuleave"));
		this.audio.AddTrack(new Track(this.basepath + "tracks/menuortiz" + Settings.audioFormat, "menu"));

		// this.translation.PrepareResources(resourceManager);
		service.translator.PrepareResources(resourceManager)

		this.robotPlay.PrepareResources(resourceManager);

		// this.loadTimer = window.setTimeout(() => { 
		// 	Log.Error(this.logGroup, "Did not load in time");
		// 	window.location.reload(); }, 120 * 1000);
		//resourceManager.Load();
		//resourceManager.ReadyToLoad();

		this.popupMessage.PrepareResources(resourceManager);

		this.audio.GetNewResources().forEach(r => resourceManager.Add(r));

		if (this.jackpotDisplay) {
			await this.jackpotDisplay.PrepareResources(loadingStage, resourceManager);
		}

		// resourceManager.AddOnStart((resources: Resource[]) => {

		// 	this.resources = resources;

		// protocol.Send("FrontendReady", {
		// 	code: null,
		// 	resources: resources.map(r => r.GetPaths()).reduce((acc: string[], curr: string[]) => [...acc, ...curr], [])
		// });
		// });

		//GlobalLoadCoordinator.Instance.ScreenReadyToLoad("");
	}

	private isClassicGame: boolean = false;

	protected async PrepareResourcesGames(loadingStage: LoadingStage, resourceManager: ResourceManager): Promise<void> {
		// // prepare resources of all games
		// if (loadingStage == LoadingStage.GamesPreload)
		// {
		// 	resourceManager.SetCurrentGame(this.loadResponse.Data.GameConfig.Meta.onlineParams.original);
		// 	await this.slotGame.PrepareResources(loadingStage, resourceManager);
		// 	this.audio.GetNewResources().forEach(r => resourceManager.Add(r));
		// 	resourceManager.SetCurrentGame(null);
		// }

		if (loadingStage == LoadingStage.Games) {
			// for (let [name, game] of this.slotGames)
			// {
			resourceManager.SetCurrentGame(this.loadResponse.Data.GameConfig.Meta.onlineParams.original);
			await SlotGameType1Shared.Instance().ResourcesPrepare(loadingStage, resourceManager);

			this.isClassicGame = this.loadResponse.Data.GameConfig.Meta.onlineParams.settings == 'Classic';


			if (this.slotGame.GetPresentation()) {
				resourceManager.AddGlobal(new PixiSpriteResource(`${Settings.ResourcesFolder}multigame/slot/${this.slotGame.name}/resources/title_sprite2`, ResourceIdentifier.Global.Add(this.slotGame.name).Add("title"), true, this.logGroup.Add(this.slotGame.name).Add("title"), true));
			}

			resourceManager.SetCurrentGame(null);
			// };
			if (!this.isClassicGame) {
				const gameName = this.loadResponse.Data.GameConfig.Meta.onlineParams.original;
				resourceManager.SetCurrentGame(gameName);
				this.awardJPDebugShow.PrepareResources(resourceManager);
				resourceManager.SetCurrentGame(null);
			}
		}

		resourceManager.SetCurrentGame(this.loadResponse.Data.GameConfig.Meta.onlineParams.original);
		await this.slotGame.PrepareResources(loadingStage, resourceManager);
		this.audio.GetNewResources().forEach(r => {
			resourceManager.SetCurrentGame(this.loadResponse.Data.GameConfig.Meta.onlineParams.original);
			resourceManager.Add(r)
			resourceManager.SetCurrentGame(null);

		});
		// await this.slotGame.PrepareResources(loadingStage, resourceManager);
	}

	// step 7
	public LoadProgress(percent: number): void {
		if (!this.smoothLoadProgress) {
			this.smoothLoadProgress = new SmoothLoadProgress((displayPercent) => {
				const strPercent = Math.round(displayPercent) + "%";
				if (this.progressDone) this.progressDone.style.width = strPercent;
				if (this.progressPercent) this.progressPercent.innerHTML = strPercent;
			});
		}
		this.smoothLoadProgress.SetReal(percent);
	}

	protected malfunction: HTMLElement = null;
	protected resourcesLoaded: boolean = false;


	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage == LoadingStage.System) {
			await this.ResourcesLoadedSystem(resourceManager);
			if (this.jackpotDisplay) {
				await this.jackpotDisplay?.ResourcesLoaded(loadingStage, resourceManager);
				// this.singlegameView.appendChild(this.jackpotDisplay.View());
			}
		}
		else if (loadingStage == LoadingStage.Finished) {
			await this.ResourcesLoadedFinished(resourceManager);
		}
		else {
			await this.ResourcesLoadedGames(loadingStage, resourceManager);
		}
		// else if (loadingStage == LoadingStage.GamesConfig)
		// 	await this.ResourcesLoadedGames(loadingStage, resourceManager);

		// if (loadingStage == LoadingStage.GamesPreload)
		// 	await this.ResourcesLoadedGames(loadingStage, resourceManager);


		// if (loadingStage == LoadingStage.Games)
		// 	await this.ResourcesLoadedGames(loadingStage, resourceManager);


		// else if (loadingStage == LoadingStage.Finished)
		// 	await this.ResourcesLoadedFinished(resourceManager);
	}

	public async LoadFinishedSuccess() {
		this.smoothLoadProgress?.Complete();
	}

	protected async ResourcesLoadedFinished(resourceManager: IReadOnlyResourceManager): Promise<void> {
		// this.CheckJackpotDisplayLevels()
		const rawMaxVolumeLevel = Number(service?.backendSettings?.GetNum("system.maxVolume", 50));
		let maxVolumeLevel = Number.isFinite(rawMaxVolumeLevel) ? rawMaxVolumeLevel / 100 : 0.5;
		maxVolumeLevel = Math.min(1, Math.max(0, maxVolumeLevel));

		this.audio.SetMaxVolumeFactor(maxVolumeLevel);
		this.audio.SetVolume(service?.backendSettings?.GetNum("system.defaultVolume", 2) ?? 2);
		this.audio.Play("menuenter");

		let gameName = this.loadResponse.Data.GameConfig.Meta.onlineParams.original;
		const gameBackground = this.resourceManager.Get<ImageResource>(this.resid.ScopedResourceName([gameName, "background" + Settings.Screens + "S"]));
		this.multigameViewBackground.style.backgroundImage = gameBackground.CssBackground();

		// Wait for background decode/paint before hiding the loader and revealing the game.
		await this.slotGame?.EnsureBackgroundReadyForReveal();

		this.smoothLoadProgress?.Complete();
		this.smoothLoadProgress?.Stop();
		this.loadingContainer.style.display = "none";
		this.stateMachine.ChangeState(SinglegameState.Running);
		this.resourceManager?.EnablePostFinishResourceAdd(true);
		await this.FrontendLoaded();
	}

	// protected CheckJackpotDisplayLevels()
	// {
	// 	assertNotNullish(this.slotGame.InitData, "Init data must be set when checking jackpot display levels");

	// 	// check when jackpot display is disabled?
	// 	let ok = true;
	// 	if (Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay)
	// 	{
	// 		// all games must have jackpot disabled
	// 			if (this.slotGame.InitData.JackpotEnabled)
	// 			{
	// 				ok = false;
	// 				// eslint-disable-next-line @typescript-eslint/no-floating-promises
	// 				void this.api.frontendError(`game ${this.slotGame.name} has JackpotEnabled, but it should be disabled for PaytableJackpotDisplay`);
	// 			}

	// 		if (ok)
	// 		{
	// 			// eslint-disable-next-line @typescript-eslint/no-floating-promises
	// 			void this.api.frontendError(`All games have jackpot displayed ok`);
	// 		}
	// 		else
	// 		{
	// 			// eslint-disable-next-line @typescript-eslint/no-floating-promises
	// 			void this.api.frontendError(`Some games have error in jackpot display, check other logs`);
	// 		}

	// 		return;
	// 	}

	// 	assertNotNullish(jackpotDisplayGlobalResponsive, "Jackpot display must be created when checking jackpot display levels");


	// 	const jackpotDisplayLevels = jackpotDisplayGlobalResponsive.JackpotLevels();

	// 	// for each game, check that the available jackpot levels are the same as the jackpot display
	// 		if (this.slotGame.InitData.JackpotEnabled)
	// 		{
	// 			let gameok = true;

	// 			assertNotNullish(this.slotGame.InitData.AvailableJackpots, "Available jackpots in init data must be set when checking jackpot display levels");

	// 			// all levels from initData must be in jackpot display
	// 			const levelsInGameNotInJackpotDisplay = this.slotGame.InitData.AvailableJackpots.filter(j => jackpotDisplayLevels.indexOf(j) == -1);
	// 			if (levelsInGameNotInJackpotDisplay.length > 0)
	// 			{
	// 				gameok = false;
	// 				// eslint-disable-next-line @typescript-eslint/no-floating-promises
	// 				void this.api.frontendError(`game ${this.slotGame.InitData.Name}} has jackpot levels that are not in jackpot display: ${levelsInGameNotInJackpotDisplay.join(", ")}`);
	// 			}

	// 			// all levels from jackpot display must be in initData
	// 			const levelsInJackpotDisplayNotInGame = jackpotDisplayLevels.filter(j => this.slotGame.InitData.AvailableJackpots.indexOf(j) == -1);
	// 			if (levelsInJackpotDisplayNotInGame.length > 0)
	// 			{
	// 				gameok = false;
	// 				// eslint-disable-next-line @typescript-eslint/no-floating-promises
	// 				void this.api.frontendError(`jackpot display has jackpot levels that are not in game: ${levelsInJackpotDisplayNotInGame.join(", ")}`);
	// 			}

	// 			if (gameok)
	// 			{
	// 				// eslint-disable-next-line @typescript-eslint/no-floating-promises
	// 				void this.api.frontendError(`game ${this.slotGame.InitData.Name} has jackpot levels that are in jackpot display: ${levelsInGameNotInJackpotDisplay.join(", ")}`);
	// 			}

	// 			ok = ok && gameok;

	// 		}
	// 		else
	// 		{
	// 			ok = false;
	// 			// eslint-disable-next-line @typescript-eslint/no-floating-promises
	// 			void this.api.frontendError(`game ${this.slotGame.InitData.Name}} does not have JackpotEnabled`); 
	// 		}	
	// 	if (ok)
	// 	{
	// 		// eslint-disable-next-line @typescript-eslint/no-floating-promises
	// 		void this.api.frontendError(`All games have jackpot displayed ok`);
	// 	}
	// 	else
	// 	{
	// 		// eslint-disable-next-line @typescript-eslint/no-floating-promises
	// 		void this.api.frontendError(`Some games have error in jackpot display, check other logs`);
	// 	}
	// }

	protected async ResourcesLoadedSystem(resourceManager: IReadOnlyResourceManager): Promise<void> {
		// Log.Debug(this.logGroup, "Load finished");
		clearTimeout(this.loadTimer);


		// this.singlegameView.querySelector<HTMLElement>(".loading").style.display = "none";




		this.gamesContainer = CreateElement("div", {
			classes: ["games"],
			parentToAppend: this.multigameViewBackground,
			style: {
				//position: "absolute",
				width: "100%",//Settings.ScreenWidth + "px",
				height: "100%",//Settings.ScreenHeight + "px",
				display: "none",
			}
		});

		this.malfunction = document.createElement("div");
		this.malfunction.classList.add("malfunction");
		SetStyles(this.malfunction,
			{
				position: "absolute",
				top: "0px",
				left: "5px",
				width: "600px",
				height: "55px",
				fontFamily: "NotoSansDisplay-BoldItalic",
				fontSize: "15px",
				color: "white",
				//zIndex:"10000",
				zIndex: "" + ZIndex.Malfunction,
				textShadow: "0px 0px 10px black, 0px 0px 20px black, 0px 0px 30px black",

			});
		//this.malfunction.innerHTML = "Malfunction voids all pays and plays";

		if (Settings.ScreenConfiguration == ScreenConfiguration.SeparateScreens) {
			this.singlegameView.appendChild(this.malfunction);
		}

		this.singlegameView.appendChild(this.gamesContainer);



		let sharedView = SlotGameType1Shared.Instance().View();
		if (sharedView) {
			this.gamesContainer.appendChild(sharedView);
		}

		this.singlegameView.appendChild(this.popupMessage.View());

		Log.Debug(this.logGroup, "Notifying games");


		//this.gamesContainer.style.display = "none";
		this.malfunction.appendChild(this.translation.Anchor(() => this.translation.t.mailfuncion));

		// check if everything loaded successfully
		this.loadErrorsContainer = document.createElement("div");
		this.loadErrorsContainer.classList.add("loadErrorsContainer");
		this.loadErrorsContainer.style.position = "absolute";
		this.loadErrorsContainer.style.top = "20px";
		this.loadErrorsContainer.style.left = "20px";
		this.loadErrorsContainer.style.right = "20px";
		this.loadErrorsContainer.style.bottom = "20px";
		this.loadErrorsContainer.style.backgroundColor = "black";
		this.loadErrorsContainer.style.color = "white";
		this.loadErrorsContainer.style.overflow = "scroll";
		//

		//let failedResources: Resource[] = GlobalLoadCoordinator.Instance.FailedResources();
		// this.resourceManager.FailedResource();

		// if (failedResources && failedResources.length > 0) {
		// 	let failedContents: string = "";

		// 	for (let i = 0; i < failedResources.length; i++) {
		// 		failedContents += `<div class="resource" style="border: 1px solid white">Failed to load:<div class="type">${failedResources[i].constructor.name}</div><div class="name">${failedResources[i].name}</div><div class="path">${failedResources[i].path}</div></div>`
		// 	}

		// 	this.loadErrorsContainer.innerHTML = failedContents;
		// 	this.multigameView.appendChild(this.loadErrorsContainer);
		// }
		// else
		// {
		// 	// Log.Debug(this.logGroup, "No failed resources!");
		// }

		this.robotPlay.ResourcesLoaded(resourceManager);
		this.robotPlay.OnGameExit();
		this.singlegameView.appendChild(this.robotPlay.View());

		// lock
		this.lock.ResourcesLoaded(resourceManager);
		this.singlegameView.appendChild(this.lock.View());

		const rawMaxVolumeLevel = Number(this.backendSettings.GetNum("system.maxVolume", 50));
		const maxVolumeLevel = Number.isFinite(rawMaxVolumeLevel) ? Math.min(1, Math.max(0, rawMaxVolumeLevel / 100)) : 0.5;
		this.audio.SetMaxVolumeFactor(maxVolumeLevel);
		this.audio.SetVolume(this.backendSettings.GetNum("system.defaultVolume", 2));
		this.audio.Play("menuenter");

		this.translation.ResourcesLoaded(resourceManager);

		//add popupMessage to current view
		this.popupMessage.ResourcesLoaded(resourceManager);
		this.singlegameView.appendChild(this.popupMessage.View());
		//this.popupMessage.CallPayoutMenu= () =>	this.payoutMenu.Show(this.clientState.Balance())


		this.ApplyFirstCashin();

		// TODO zelo pomembno. ... nesnaga 
		Log.Debug(this.logGroup, "Waiting some time for frontend to settle");

		// setTimeout(() => {
		// 	this.stateMachine.ChangeState(MultigameState.Running);
		// 	this.FrontendLoaded();
		// }, 2000);


		if (Settings.KeyboardEnabled) {
			window.addEventListener("keydown", (event) => this.OnKeyUpDown(event.key, true));
			window.addEventListener("keyup", (event) => this.OnKeyUpDown(event.key, false));
		}
		window.addEventListener("keydown", (event) => this.api.keyboard(event.key, true));
		window.addEventListener("keyup", (event) => this.api.keyboard(event.key, false));
	}

	protected ShowFreeRoundsPopup() {

		// if (!this.FreeRoundsAvailable(this.freeRoundsStats.FreeRoundsNumber, this.freeRoundsStats.PlayedFreeRoundsNumber)) {
		// 	return;
		// }
		// this.freeRoundsMessageShowed = true;

		this.popupMessage.ShowPopupMessage({
			Title: this.translation.Translate(() => this.translation.t.freeroundTitle).translation(),
			Text: this.translation.Translate(() => this.translation.t.freeroundmessage(this.freeRoundsStats, this.moneyFormatter.FormatCurrency(this.freeRoundsStats.FreeRoundsBet))).translation(),
			DisplayType: DisplayType.PopUp,
			Buttons: [
				{
					Text: "Continue",
					Action: "continue",
					Link: null,
					LinkType: LinkType.Disable,
				},
			]
		});
	}

	private FreeRoundsAvailable(totalFreeRounds: number, freeRoundsPlayed: number): boolean {
		return (totalFreeRounds != freeRoundsPlayed) ? true : false;
	}

	protected async ResourcesLoadedGames(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		// if (loadingStage == LoadingStage.GamesConfig)
		// {
		// }
		// if (loadingStage == LoadingStage.Games)
		// {
		if (loadingStage == LoadingStage.Games) {
			let sharedView = SlotGameType1Shared.Instance().View();
			if (sharedView) {
				this.singlegameView.appendChild(sharedView);
				sharedView = null;
			}

			resourceManager.SetCurrentGame("Shared-Online");
			{
				await SlotGameType1Shared.Instance().ResourcesLoaded(loadingStage, resourceManager);
				//MENU FACTORY
				// await this.gamesMenu.ResourcesLoaded(resourceManager);
				// this.multigameView.appendChild(this.gamesMenu.View());
				// this.gamesMenu.Show();
			}
			resourceManager.SetCurrentGame(null);

			if (!this.isClassicGame) {
				await this.awardJPDebugShow.ResourcesLoaded(resourceManager);
			}
			// resourceManager.SetCurrentGame("DoubleUp");
			// await this.doubleUpgame?.CardsLoaded(resoursceManager);
			// resourceManager.SetCurrentGame(null);
		}


		let view: HTMLElement = this.slotGame.View();

		view.classList.add("game");
		view.style.position = "relative";
		view.style.display = "none";

		this.gamesContainer.appendChild(view);
		// }
		resourceManager.SetCurrentGame(this.loadResponse.Data.GameConfig.Meta.onlineParams.original);
		await this.slotGame.ResourcesLoaded(loadingStage, resourceManager);
		resourceManager.SetCurrentGame(null);

		// this.slotGame.OnBetSelect = (selectedBet) => this.OnBetSelectCallback?.(selectedBet);
		this.slotGame.GameStartedCallback = () => this.GameStarted();
		this.slotGame.GameEndedCallback = () => this.GameEnded();

		this.slotGame.GameStateChanged = (state) => this.MultigameGameStateChanged?.(state);
		this.slotGame.UpdateDenom = (bets, denom) => this.MultigameUpdateDenom?.(bets, denom);
		this.slotGame.OnBetSelect = (selectedBet) => {
			this.OnBetSelectCallback?.(selectedBet);
			this.UpdateFreeRoundsStats();
		}
	}

	public MultigameGameStateChanged: SinglegameGameStateChangedCallback = null;
	public MultigameUpdateDenom: SinglegameUpdateDenomCallBack = null;

	protected GameStarted(): void {
		this.StopIdleTimer("GameStarted");
	}

	protected GameEnded(): boolean {
		this.StartIdleTimer("GameEnded");

		// if (this.handpayPendingParams?.PendingHandpays?.length) {
		// 	//this.lock.Start("**", "HandpayPending - " + this.handpayPendingParams.PendingHandpays[0].HandpayReason);
		// 	this.lock.StartFrontend("HandpayPending - " + this.handpayPendingParams.PendingHandpays[0].HandpayReason, "**")
		// 	return false;
		// }

		return true;
	}

	StartIdleTimer(reason: string) {
		Log.Debug(this.logGroup, "StartIdleTimer() reason: " + reason);

		// if (!this.stateMachine.IsState(SinglegameState.Running))
		// {
		// 	// game is not running, don't start idle timer
		// 	return;
		// }

		// if (this.slotGame)
		// {
		// 	this.TryStartReturnToMenuTimer2(reason);
		// }
		// else
		// {
		// 	this.TryAutoSelectNextGame(reason);
		// }
	}

	StopIdleTimer(reason: string) {
		Log.Debug(this.logGroup, "StopIdleTimer() reason: " + reason);
		// this.returnToMenuTimer.Stop();
		// this.selectNextGameTimer.Stop();
	}

	public async LoadFailed(loadingStage: LoadingStage, failed: Resource[]): Promise<void> {
		this.loadErrorsContainer = document.createElement("div");
		this.loadErrorsContainer.classList.add("loadErrorsContainer");
		SetStyles(this.loadErrorsContainer, {
			position: "absolute",
			top: "20px",
			left: "20px",
			right: "20px",
			bottom: "20px",
			backgroundColor: "black",
			color: "white",
			overflow: "scroll",
		});


		let failedContents: string = "";
		for (let i = 0; i < failed.length; i++) {
			failedContents += `<div class="resource" style="border: 1px solid white">Failed to load:<div class="type">${failed[i].constructor.name}</div><div class="name">${failed[i].name}</div><div class="path">${failed[i].path}</div></div>`
		}

		this.loadErrorsContainer.innerHTML = failedContents;
		this.singlegameView.appendChild(this.loadErrorsContainer);
		await this.checkAllReosurcesList();
	}

	protected async checkAllReosurcesList() {
		let reportResources = true;
		if (reportResources) {
			// get list of resources and report them to backend
			let listOfResources: ResourceMeta[] = this.resourceManager.GetResources()
				// get resource paths (each resource can have multiple paths, sprite has 2 for image and json)
				.map(r => ({
					name: r.Name,
					type: r.Type,
					paths: r.GetPaths()
				}));


			const batchSize = 100;
			const numBatches = Math.ceil(listOfResources.length / batchSize);

			for (let i = 0; i < numBatches; i++) {
				const start = i * batchSize;
				const end = Math.min((i + 1) * batchSize, listOfResources.length);
				await this.api.frontendResources(listOfResources.slice(start, end));
			}
		}

	}


	protected async FrontendLoaded() {
		// if (Settings.LangugeInit == LanguageInit.SpanishTranslation) {
		// 	this.translation.ChangeLanguage(SpanishTranslation.locality);
		// }
		// else if (Settings.LangugeInit == LanguageInit.EnglishTranslation) {
		// 	this.translation.ChangeLanguage(EnglishTranslation.locality);
		// }


		this.resourcesLoaded = true;

		// this.responsiveFreeRoundsContainer = CreateElement("div", {
		// 	classes: ["responsive-free-round", "container"],
		// 	parentToAppend: this.singlegameView,
		// 	style: {
		// 		// border: "5px solid red",
		// 		boxSizing: "border-box",
		// 		flexGrow: "1",
		// 		position: "fixed",
		// 		zIndex: "10",
		// 		visibility: "hidden",
		// 		marginLeft: "1%"
		// 	}
		// });

		// this.freeRoundsContainerFit = CreateElement("div", {
		// 	classes: ["responsive-free-round", "container-fit"],
		// 	parentToAppend: this.responsiveFreeRoundsContainer,
		// 	style: {
		// 		// border: "5px solid red",
		// 		boxSizing: "border-box",

		// 		width: "100%",
		// 		height: "100%",
		// 		display: "flex",
		// 		alignItems: "center",
		// 		justifyContent: "center"
		// 	}
		// });

		// this.freeRoundsCounterSpin = CreateElement("div", {
		// 	classes: ["freerounds-counter-spin"],
		// 	parentToAppend: this.freeRoundsContainerFit,
		// 	style: {

		// 		width: Scale.Wpx(375),
		// 		// height: Scale.Hpx(187.5),
		// 		position: "relative",
		// 		border: 'solid gold',
		// 		backgroundColor: "black",
		// 		color: "white",
		// 		textAlign: "center",
		// 		borderRadius: `${Scale.XYpx(60)}`,
		// 		borderImageSlice: `${Scale.fh(135)} ${Scale.fh(135)} ${Scale.fh(135)} ${Scale.fh(135)}`,
		// 		borderImageWidth: `${Scale.fh(22.5)} ${Scale.fh(22.5)} ${Scale.fh(22.5)} ${Scale.fh(22.5)}`,
		// 		borderImageRepeat: "stretch stretch",
		// 		borderStyle: "solid",
		// 		display: "flex",
		// 		flexDirection: "column",
		// 		alignItems: "center",

		// 	}
		// });

		// this.freeRoundsCounter = CreateElement("div", {
		// 	classes: ["freerounds-counter"],
		// 	parentToAppend: this.freeRoundsCounterSpin,
		// 	style: {

		// 		width: "100%",
		// 		height: "100%",
		// 		display: "flex",
		// 		alignItems: "center",
		// 		justifyContent: "center",
		// 		color: "white",
		// 	},
		// });

		// this.UpdateFreeRoundsStats(this.loadResponse.Data.FreeRoundsStats);
		this.freeRoundsStats = this.loadResponse.Data.freeRoundsStats;
		this.clientState

		// this.translation.SetOnLanguageChangedCallback(() =>
		// 	this.freeRoundsCounter.innerHTML = this.translation.Translate(() => this.translation.t.freerRoundCounterText(this.loadResponse.Data.FreeRoundsStats.FreeRoundsNumber - this.freeRoundsStats.PlayedFreeRoundsNumber)).translation()
		// );

		// this.ShowFreeRoundsPopup();


		// let reportResources = true;
		// if (reportResources)
		// {
		// 	// get list of resources and report them to backend
		// 	let listOfResources = this.resources
		// 		// get resource paths (each resource can have multiple paths, sprite has 2 for image and json)
		// 		.map(r => r.GetPaths())

		// 		// merge all paths to one big array
		// 		.reduce((acc: string[], curr: string[]) => [...acc, ...curr], [])

		// 		// remove different starting symbols
		// 		.map(p => {
		// 			if (p.startsWith("./")) return p.substring(2);
		// 			if (p.startsWith("/")) return p.substring(1);
		// 			return p;
		// 		})

		// 		// sort
		// 		.sort()

		// 		// filter unique only
		// 		.filter((p, i, arr) => arr.indexOf(p) == i);

		// 	this.api.frontendResources(listOfResources);
		// }


		await this.checkAllReosurcesList();
		await this.api.frontendLoadingComplete({
			SessionToken: this.sessionToken,
			Request: {
				BetIndex: this.currentBetIndex
			}
		});

		this.StartMenuAudio();

		//this.GameSelect(gamename);
		await this.ShowGame();
	}

	protected pingTimer: IInterval = null;
	protected async SendPing() {
		await this.api.ping();
	}

	protected PlayMenuAudio() {
		Log.Debug(this.logGroup, "MenuAudio - PlayMenuAudio()");

		//this.audio.Stop("menu");
		//this.audio.Play("menu");
	}

	protected StartMenuAudio() {
		this.menuAudioRepeatTimer.Stop();
		this.menuAudioInitialDelayTimer.Restart();
	}

	protected StopMenuAudio() {
		this.audio.Stop("menu");
		this.menuAudioInitialDelayTimer.Stop();
		this.menuAudioRepeatTimer.Stop();
	}

	//protected keysPressed: Map<string, boolean> = new Map<string, boolean>();
	protected keysPressed: string[] = [];
	protected KeysPressed(keys: string[]): boolean {
		for (let i = 0; i < keys.length; i++) {
			if (this.keysPressed.indexOf(keys[i]) == -1) {
				return false;
			}
		}

		return true;
	}

	// keyboard
	readonly keyState: Map<string, Boolean> = new Map<string, boolean>();

	pressedKeys: string = "";

	debugUpdateCallbacks: Map<string, () => void> = new Map<string, () => void>();

	protected DebugUpdate() {
		this.debugUpdateCallbacks?.forEach((callback: () => void, key: string) => {
			callback();
		});
	}

	// protected appDebbugerTranstion : PIXI.Application<HTMLCanvasElement> = null

	protected async OnKeyUpDown(k: string, pressed: boolean) {

		let key: string = k.toLowerCase();

		// if (pressed && this.keyState.get(key))
		// {
		// 	// already pressed
		// 	return;
		// }
		let matchArray: RegExpMatchArray;


		if (pressed) {

			this.pressedKeys += key;
			const maxLength = 20;
			if (this.pressedKeys.length > maxLength) {
				this.pressedKeys = this.pressedKeys.slice(-maxLength);
			}
			console.log("pressed " + key + ", spells: " + this.pressedKeys);
		}


		if (pressed) {
			//this.keysPressed.push(key);
			this.keyState.set(key, true);
		}
		else {
			//this.keysPressed.splice(this.keysPressed.indexOf(key), 1);
			this.keyState.delete(key);
		}

		// only do it on pressed
		if (!pressed) {
			return;
		}
		else if (this.pressedKeys.endsWith("spin")) {
			if (this.pressedKeys.endsWith("spin")) {
				// emulate ioboard button spin press
				service.iomanager.FakeInput(InputFunction.ButtonSpin, pressed);
			}
			else {
				this.OnButtonChanged(Button.ButtonSpin, pressed);
			}
		}
		else if (this.pressedKeys.endsWith("autoplay")) {
			service.iomanager.FakeInput(InputFunction.ButtonAutoplay, pressed);
		}
		else if (this.pressedKeys.endsWith("crashcanvas")) {
			crashcanvas();
		}
		else if (this.pressedKeys.endsWith("crashvideo")) {
			crashvideo();
		}
		else if (this.pressedKeys.endsWith("payout")) {
			this.OnButtonChanged(Button.ButtonPayout, true);
			this.OnButtonChanged(Button.ButtonPayout, false);
		}
		else if (this.pressedKeys.endsWith("callattendant")) {
			this.OnButtonChanged(Button.ButtonCallAttendant, true);
			this.OnButtonChanged(Button.ButtonCallAttendant, false);
		}
		else if (this.pressedKeys.endsWith("fit")) {
			let stretch = this.keyState.has("shift");
			FitScreen(stretch ? "stretch" : "fit");
		}
		else if (this.pressedKeys.endsWith("robotenter")) {
			if (this.robotPlay.IsEnabled()) {
				this.robotPlay.Disable();
			}
			else {
				this.robotPlay.Enable({
					...RobotParamsDefault,
					playType: RobotPlayType.CurrentGame,
				});
			}
		}
		else if (this.pressedKeys.endsWith("fountstart")) {
			// 	if (SlotGameType1Shared.Instance().smallFountainAnimation.Running()) {
			// 		SlotGameType1Shared.Instance().smallFountainAnimation.RequestStop(this.resid);
			// 	}
			// 	else {
			// 		SlotGameType1Shared.Instance().smallFountainAnimation.Start(this.resid);
			// 	}
			// }
			// else if (this.pressedKeys.endsWith("fount2enter")) {
			// 	if (SlotGameType1Shared.Instance().mediumFountainAnimation.Running()) {
			// 		SlotGameType1Shared.Instance().mediumFountainAnimation.RequestStop(this.resid);
			// 	}
			// 	else {
			// 		SlotGameType1Shared.Instance().mediumFountainAnimation.Start(this.resid);
			// 	}
			// }
			// else if (this.pressedKeys.endsWith("fount3enter")) {
			// 	if (SlotGameType1Shared.Instance().bigFountainAnimation.Running()) {
			// 		SlotGameType1Shared.Instance().bigFountainAnimation.RequestStop(this.resid);
			// 	}
			// 	else {
			// 		SlotGameType1Shared.Instance().bigFountainAnimation.Start(this.resid);
			// 	}
			await this.slotGame.CreateFountain();
		}
		else if (this.pressedKeys.match(/win([0-9]+)enter$/)) {
			let match = this.pressedKeys.match(/win([0-9]+)enter$/);
			let winIndex = parseInt(match[1]);
			void this.slotGame?.DebugWinPresentation(winIndex);
		}
		else if (this.pressedKeys.match(/winhold([0-9]+)enter$/)) {
			let match = this.pressedKeys.match(/winhold([0-9]+)enter$/);
			let winIndex = parseInt(match[1]);
			void this.slotGame?.DebugWinPresentation(winIndex, { autoStop: false });
		}
		else if (this.pressedKeys.endsWith("winstopenter")) {
			this.slotGame?.DebugStopWinPresentation();
		}
		else if (this.pressedKeys.endsWith("fountstop")) {
			await this.slotGame.StopFountain();
		}
		else if (this.pressedKeys.endsWith("fountdestroy")) {
			this.slotGame.destroyFountain();
		}
		else if (this.pressedKeys.endsWith("translate")) {
			service.translator.NextLanguage();
		}
		else if (this.pressedKeys.endsWith("popup")) {
			this.popupMessage.ShowPopupMessage({
				Title: "Attention player",
				Text: "You have been playing for very long time. For gambling addiction please go to ....link",
				DisplayType: DisplayType.Notification,
				Buttons: [
					{

						Text: "Quit",
						Action: "quit",
						Link: null,
						LinkType: LinkType.Disable,
					},
					{

						Text: "Link",
						Action: "link",
						Link: "http://www.google.com",
						LinkType: LinkType.Redirect,
					},
					{

						Text: "Continue",
						Action: "continue",
						Link: null,
						LinkType: LinkType.Disable,
					},
					{

						Text: "Cashier",
						Action: "cashier",
						Link: null,
						LinkType: LinkType.Disable,
					}
				]
			});
		}
		else if (this.pressedKeys.endsWith("crpixi")) {
			//this.slotGame.PixiCanvasCrash();
			CrashPixi()
		}
		// Freegames debugger — uncomment to enable
		// else if (this.pressedKeys.endsWith("fgenter") || this.pressedKeys.endsWith("freegamesenter")) {
		// 	void (globalThis as { __DIXPA_DEBUG__?: { triggerFreegames?: () => Promise<void> } }).__DIXPA_DEBUG__?.triggerFreegames?.();
		// }
		// else if (this.pressedKeys.endsWith("fgwildenter") || this.pressedKeys.endsWith("freegameswildenter")) {
		// 	void (globalThis as { __DIXPA_DEBUG__?: { triggerFreegamesWild?: () => Promise<void> } }).__DIXPA_DEBUG__?.triggerFreegamesWild?.();
		// }
		else if (this.pressedKeys.endsWith("lastenter")) {

			const lastGame: SimpleSlotGameState = JSON.parse(localStorage.getItem(this.slotGame.InitData.Meta.GameName));


			if (!lastGame) {
				console.warn("No last game found");
				return;
			}

			this.slotGame.ContinueUnfinishedGame(lastGame);

		}
		else if (this.pressedKeys.endsWith("bwenter")) {
			this.slotGame.StartBigWinBaseGame();
		}
		else if (this.pressedKeys.endsWith("rdwreels")) {
			this.slotGame?.RedrawAllReels?.();
		}
		else if (this.pressedKeys.endsWith("credit")) {
			await this.api.keyboard("credit", pressed);
		}
		else if (this.pressedKeys.endsWith("levelenter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("level");
		}
		else if (this.pressedKeys.endsWith("pathsraenter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("pathsra");
		}
		else if (this.pressedKeys.endsWith("pathsraallenter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("pathsraall");
		}
		else if (this.pressedKeys.endsWith("bonusenter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("bonusfilling");
		}
		else if (this.pressedKeys.endsWith("antienter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("anticipation");
		}
		else if (this.pressedKeys.endsWith("ra1enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("ra1enter");
		}
		else if (this.pressedKeys.endsWith("ra2enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("ra2enter");
		}
		else if (this.pressedKeys.endsWith("ra3enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("ra3enter");
		}
		else if (this.pressedKeys.endsWith("ra4enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("ra4enter");
		}
		else if (this.pressedKeys.endsWith("ra5enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("ra5enter");
		}
		else if (this.pressedKeys.endsWith("ra6enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("ra6enter");
		}
		else if (this.pressedKeys.endsWith("ra7enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("ra7enter");
		}
		else if (this.pressedKeys.endsWith("ra8enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("ra8enter");
		}
		else if (this.pressedKeys.endsWith("ra9enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("ra9enter");
		}
		else if (this.pressedKeys.endsWith("ra10enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("ra10enter");
		}
		else if (this.pressedKeys.endsWith("skin1enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("skin1");
		}
		else if (this.pressedKeys.endsWith("skin2enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("skin2");
		}
		else if (this.pressedKeys.endsWith("skin3enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("skin3");
		}
		else if (this.pressedKeys.endsWith("skin4enter")) {
			this.slotGame?.FillingPotDebuggerAnims?.("skin4");
		}
		else if (this.pressedKeys.endsWith("jp1senter")) {

			let videoResId = ResourceIdentifier.Global.Add("jp1");
			let video = this.systemContext.SharedVideoContainer().GetVideo(videoResId);
			video?.Show();
			video?.Play(ResourceIdentifier.Global.Add("jp1test"));
		}
		else if (this.pressedKeys.endsWith("jp1eenter")) {
			let videoResId = ResourceIdentifier.Global.Add("jp1");
			let video = this.systemContext.SharedVideoContainer().GetVideo(videoResId);
			video?.StopAndReset(ResourceIdentifier.Global.Add("jp1test"));
		}
		// else if (this.pressedKeys.endsWith("jpsharedenter")) {
		// 	if (!this.slotGame)
		// 		{
		// 			console.log("no game selected");
		// 			return;
		// 		}

		// 		this.slotGame.JPSharedDebugger();
		// }

		else if (this.pressedKeys.match(/inon[0-9]+enter$/)) {
			let match = this.pressedKeys.match(/inon([0-9]+)enter$/);
			let input = parseInt(match[1]);
			service.iomanager.SetInput(input, InputState.RisingEdge);
		}
		else if (this.pressedKeys.match(/inoff[0-9]+enter$/)) {
			let match = this.pressedKeys.match(/inoff([0-9]+)enter$/);
			let input = parseInt(match[1]);
			service.iomanager.SetInput(input, InputState.FallingEdge);
		}
		else if (this.pressedKeys.endsWith("transenter")) {
			if (!this.slotGame) {
				console.log("no game selected");
				return;
			}

			let bonusList = (this.slotGame as any as SlotGameType1).BonusList();

			let bonus = (bonusList.get("ExtendedSpinAndHold") ?? bonusList.get("SpinAndHold") ?? bonusList.get("MultiBonus"));
			if (!bonus) {
				console.log("no bonus");
				return;
			}

			// update bonus for next 10s
			this.debugUpdateCallbacks.get("debug transition")?.();
			this.debugUpdateCallbacks.set("debug transition", () => (bonus as SpinAndHoldBonus).TransitionView.Update());

			if (Settings.PresentationType == Presentation.VideoParticleTransitionFadeInFadeOut || Settings.PresentationType == Presentation.VideoParticleTransitionMatterJS) {
				// this.appDebbugerTranstion = new PIXI.Application<HTMLCanvasElement>({
				// width: window.screen.availWidth,
				// height: window.screen.availHeight,
				// backgroundAlpha: 0,
				//backgroundColor : "white"		             
				//forceCanvas: true
				// });

				// this.appDebbugerTranstion.view.style.position = "absolute";
				// this.appDebbugerTranstion.view.style.bottom = "0px";
				// this.appDebbugerTranstion.view.style.zIndex = ZIndex.BonusTransition + "";

				// let container = new PIXI.Container();
				// this.appDebbugerTranstion.stage.addChild(container);
				// this.View().appendChild(this.appDebbugerTranstion.view);
				//globalThis.__PIXI_APP__ = this.appDebbugerTranstion;
			}

			// bonus.CreateTransitionPixi(globalThis.gameViewAppPixiResponsive.GetAppView().stage);
			bonus.CreateTransitionPixi(this.gameEngineResponsive.GetAppView().stage);

			window.addEventListener("resize", () => {
				bonus.OnResize();
			});
			bonus.ShowVideoTransition();
			bonus.BackGroundTransition();

		}
		else if (this.pressedKeys.endsWith("diamondscreate")) {
			this.awardJPDebugShow.CreatePIXIAPP();
			this.awardJPDebugShow.ViewPIXIAPP().visible = true;
			// globalThis.gameViewAppPixiResponsive.GetAppView().stage.addChildAt(this.awardJPDebugShow.ViewPIXIAPP(), 0);
			this.gameEngineResponsive.GetAppView().stage.addChildAt(this.awardJPDebugShow.ViewPIXIAPP(), 0);


		}
		else if (this.pressedKeys.endsWith("diamondsdestroy")) {
			this.awardJPDebugShow.ViewPIXIAPP().visible = false;
			this.awardJPDebugShow.Destroy();

		}
		else if (matchArray = this.pressedKeys.match(/jlv(\d+)enter$/)) {
			let level = (matchArray[1]);
			this.slotGame.FillingPotDebuggerAnims(level, 0)
			//debugger per nivel and pot for multplier 
		}
		else if (matchArray = this.pressedKeys.match(/dlv(\d+)enter$/)) {
			let level = (matchArray[1]);
			this.slotGame.FillingPotDebuggerAnims(level, 1)
			//debugger per nivel and pot for multplier
		}
		else if (matchArray = this.pressedKeys.match(/mlv(\d+)enter$/)) {
			let level = (matchArray[1]);
			this.slotGame.FillingPotDebuggerAnims(level, 2)
			//debugger per nivel and pot for multplier
		}
		else if (matchArray = this.pressedKeys.match(/lv(\d+)enter$/)) {
			let level = (matchArray[1]);
			this.slotGame.FillingPotDebuggerAnims(level)
			//debugger per nivel , you select which level will be play 
		}
		else if (this.pressedKeys.endsWith("enter")) {
			console.log("Unknown command", this.pressedKeys);
		}


		/*switch (key)
		{
			
			// case "p":
			// 	this.audio.ListPlaying();
			// break;

			// make it crash (stop ping timer)
			case "c":
				if (pressed)
				{
					//this.pingTimer.Stop();
					crashcanvas();					
				}
				break;

			case "v":
				if (pressed)
				{
					crashvideo();
				}
				break;

			// goto menu as operator
			// case "o":
			// 	if(pressed)
			// 	{
			// 		service.iomanager.SetOnlyLights([
			// 			{light: ButtonLights.LightButtonSpin, state: OutputState.On}
			// 		]);
			// 	}
			// 	break;

			case "l":
				if(pressed)
				{
					service.iomanager.SetOnlyLights([
						{light: ButtonLights.LightButtonSpin, state: OutputState.Off}
					]);
				}
				break;
			case "n":
				if (pressed)
				{
					if (this.keyState.get("shift") && this.keyState.get("m")){
						let key: Key = {
							Code: "operator-keyboard",
							Permissions: [
								"operator"
							]
						};
						this.MenuEnter(key);
					}
				}
				break;

			//case "n":
			//	if (pressed)
			//		this.MenuEnter({
			//			Code: "attendant-keyboard",
			//			Permissions: [
			//				"attendant"
			//			]
			//		});
			//	break;

			if (this.pressedKeys.endsWith("factory"))
			{
					if (pressed)
					this.MenuEnter({
						Code: "factory-keyboard",
						Permissions: [
							"factory"
						]
					});
					break;

			case ",":
				if (pressed)
				{
					this.MenuEnter({
						Code: "015DC94A160000E8",
						Permissions: [
							"keys"
						]
					});
				}
				break;

			case "a":
				this.OnButtonChanged(Button.ButtonAutoplay, pressed);
				break;
			// payout
			case "p":

				if (this.keyState.get("shift"))
				{
					service.iomanager.FakeInput(InputFunction.ButtonPayout, pressed);
				}
				else
				{
					this.OnButtonChanged(Button.ButtonPayout, pressed);
				}
				break;

			case "h":
				if (this.keyState.get("shift"))
				{
					service.iomanager.FakeInput(InputFunction.ButtonCallAttendant, pressed);
				}
				else
				{
					this.OnButtonChanged(Button.ButtonCallAttendant, pressed);
				}
				break;

			// hardware spin
			case "s":
				if (this.keyState.get("shift"))
				{
					// emulate ioboard button spin press
					service.iomanager.FakeInput(InputFunction.ButtonSpin, pressed);
				}
				else
				{
					this.OnButtonChanged(Button.ButtonSpin, pressed);
				}
				break;

			case "a":
				if (this.keyState.get("shift"))
				{
					// emulate ioboard button spin press
					service.iomanager.FakeInput(InputFunction.ButtonAutoplay, pressed);
				}
				break;

			// fit game to window
			case "f":
				if (pressed)
				{
					let stretch = this.keyState.has("shift");
					FitScreen(stretch ? "stretch" : "fit");
				}

				break;

			//recovery game 
			case "u":
				if (pressed)
					this.RecoveryTest();
				break;
			//get last game 
			case "w":
				if (pressed)
					this.GetLastGame();
				break;

			// toggle robot
			case "r":
				if (pressed)
				{
					if (this.robotPlay.IsEnabled())
					{
						this.robotPlay.Disable();
					}
					else
					{
						this.robotPlay.Enable();
					}
				}

				break;

			case "d":
				if (pressed)
				{
					if (this.keyState.get("1"))
					{
						if (SlotGameType1Shared.Instance().smallFountainAnimation.Running())
						{
							SlotGameType1Shared.Instance().smallFountainAnimation.RequestStop(this.resid);
						}
						else
						{
							SlotGameType1Shared.Instance().smallFountainAnimation.Start(this.resid);
						}
					}
					else if (this.keyState.get("2"))
					{
						if (SlotGameType1Shared.Instance().mediumFountainAnimation.Running())
						{
							SlotGameType1Shared.Instance().mediumFountainAnimation.RequestStop(this.resid);
						}
						else
						{
							SlotGameType1Shared.Instance().mediumFountainAnimation.Start(this.resid);
						}
					}
					else if (this.keyState.get("3"))
					{
						if (SlotGameType1Shared.Instance().bigFountainAnimation.Running())
						{
							SlotGameType1Shared.Instance().bigFountainAnimation.RequestStop(this.resid);
						}
						else
						{
							SlotGameType1Shared.Instance().bigFountainAnimation.Start(this.resid);
						}
					}
				}
				break;

			case "p":
			//     if (pressed)
			//     {
			//         if (this.gamesMenu.IsPresentationRunning())
			//         {
			//             this.gamesMenu.StopPresentation();
			//         }
			//         else if (this.keyState.get("0"))
			//         {
			//             this.gamesMenu.StartPresentation(0);
			//         }
			//         else if (this.keyState.get("1"))
			//         {
			//             this.gamesMenu.StartPresentation(1);
			//         }
			//         else if (this.keyState.get("2"))
			//         {
			//             this.gamesMenu.StartPresentation(2);
			//         }
			//         else if (this.keyState.get("3"))
			//         {
			//             this.gamesMenu.StartPresentation(3);
			//         }
			//     }
			//     break;

			// print out what resources are not loaded yet
			case "l":
				if (pressed)
				{
					// Log.Debug(this.logGroup, "Resoures, waiting for load:");
					this.resourceManager.UnprocessedResources().forEach((resource: Resource, index: number) => {
						// Log.Debug(this.logGroup, name + " from " + resource.path);
						
						// print only 10...
						if (index >= 10) return false;
						return true;
					});
				}
				break;

			case "t":
				if (pressed) {
					service.translator.NextLanguage();
				}
				break;


			//start popupMessage
			case "y":
				if (pressed) {
					
					this.popupMessage.ShowPopupMessage({
						Title: "Attention player",
						Text: "You have been playing for very long time. For gambling addiction please go to ....link",
						DisplayType: DisplayType.Notification,
						Buttons: [
							{

								Text: "Quit",
								Action: "quit",
								Link: null,
								LinkType: LinkType.Disable,
							},
							{

								Text: "Link",
								Action: "link",
								Link: "http://www.google.com",
								LinkType: LinkType.Redirect,
							},
							{

								Text: "Continue",
								Action: "continue",
								Link: null,
								LinkType: LinkType.Disable,
							},
							{

								Text: "Cashier",
								Action: "cashier",
								Link: null,
								LinkType: LinkType.Disable,
							}
						]
					});
				}
			break;

			case "q":				
				if (pressed) {
					//this.slotGame.PixiCanvasCrash();
					CrashPixi()
				}
			break;




			case "x":
				if (pressed)
				{
					//this.slotGame?.RedrawAllReels?.();
					throw "TestCrash";
				}

			case "usa":


			default:
				//Log.Error(this.logGroup, "Unmapped key " + key);
				this.api.keyboard(key, pressed);
				break;
		}*/
	}

	public Update() {
		// don't update when crashed, causes too much logging
		if (this.crashed) return;

		// update only when running
		if (this.stateMachine.State() == SinglegameState.Running) {
			this.slotGame.Update();
			this.jackpotDisplay?.Update();
		}
	}

	protected async ShowGame(): Promise<void> {
		const view = this.slotGame.View();
		// Force CSS background paint while hidden: display:none defers paint until after UI would otherwise show.
		view.style.visibility = "hidden";
		this.Show(view);
		this.gamesContainer.style.display = "block";
		await this.slotGame.EnsureBackgroundReadyForReveal();
		view.style.visibility = "visible";
		await this.slotGame.GameSelected();
	}

	public OnButtonChanged(button: Button, pressed: boolean): void {
		if (this.robotPlay.IsEnabled()) {
			Log.Debug(this.logGroup, "Hardware key - disabling robot play")
			this.robotPlay.Disable();
		}
		else if (this.stateMachine.State() == SinglegameState.Running) {
			if (!this.lock.IsLocked()) {
				this.slotGame?.OnButtonChanged(button, pressed);
			}
		}
	}

	public OnMachineLocked(lockParams: MachineLockedParams): void {
		this.lock?.Start(lockParams);

		if (this.robotPlay?.IsEnabled()) {
			Log.Debug(this.logGroup, "MachineLocked - disabling robot play");
			this.robotPlay.Disable();
		}
	}

	public OnMachineUnlocked(): void {
		this.lock?.Stop();
	}

	protected cashInMachineStart: CashInParams = null;
	public CashIn(params: CashInParams): void {
		this.cashInMachineStart = params;

		if (this.stateMachine.State() == SinglegameState.Running) {
			this.ApplyFirstCashin();
		}

		this.slotGame?.AutoplayDisable();

		this.audio.Play(this.resid.ScopedResourceName("cashin"));

		//this.CancelReturnToMenuTimer();
	}

	protected ApplyFirstCashin() {
		if (this.loadResponse?.Data?.Balance?.InCents) {
			this.clientState.UpdateBalance(this.loadResponse.Data.Balance.InCents);
		}
		// if (this.cashInMachineStart != null)
		// {
		// 	this.clientState.CashIn(this.cashInMachineStart);
		// }
	}

	public CashOut(params: CashOutParams): void {
		this.clientState.CashOut(params);
		this.slotGame?.AutoplayDisable();
		this.audio.Play(this.resid.ScopedResourceName("cashin"));
	}

	protected SelectMinimumBets() {
		this.slotGame?.SelectMinimumBet();
	}

	public OnConnectionToBackendLost(): void {
		this.audio.StopAll();
		this.pingTimer.Stop();
	}

	public View(): HTMLElement {
		return this.singlegameView;
	}

	public Show(element: HTMLElement): void {
		element.style.display = "block";
	}

	public Hide(element: HTMLElement): void {
		element.style.display = "none";
	}

	public OnBetSelectCallback: (selectedBet: SlotGameBet) => void = null;

	public OnRotateScreen(rotateFlagScreen: boolean) {
		/*
		if (rotateFlagScreen) {
			this.multigameView.style.height = (Settings.ScreenHeight * 2) + "px";
			this.multigameView.style.bottom = (Settings.ScreenHeight * -1) + "px";
		} else {
			this.multigameView.style.height = (Settings.ScreenHeight) + "px"
		}*/
	};
	public BackgroundView(): HTMLElement {
		return this.multigameViewBackground
	}
	public async OnResize(orientation: Orientation): Promise<void> {
		await this.slotGame.OnResize(orientation);
		// if (this.awardJPDebugShow) this.awardJPDebugShow?.OnResize();
	}
	public async onOrientationChanged(orientation: Orientation): Promise<void> {
		await this.slotGame.OnResize(orientation);
	}

	public GameExit(silent?: boolean): void {

	}

}